import Telemetry from '@atlassian/mpac-telemetry';
export const viewSearchResultsTask = 'view-search-results';
export const ViewSearchResult = Telemetry.createGenericTask(viewSearchResultsTask);
export const ViewFilters = Telemetry.createGenericTask('view-filters');
export const SearchResultPageTask = Telemetry.createPageViewTask('view-search-results-page').dependsOn([ViewSearchResult, ViewFilters]);